// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__BC+wj","buttonsWrapper":"styles_buttonsWrapper__2ny-9","uploadButton":"styles_uploadButton__IKVnM"};